/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';
    
    export interface IDeviceGui {
        guiUrl: string;
        apiUrl: string;
        absolute: boolean;
        proxyType: string;
    }

    export class DeviceGui implements IDeviceGui {
        public guiUrl: string;
        public guiUrlNoProxy: string;
        public apiUrl: string;
        public absolute: boolean;
        public proxyType: string;

        public static Empty(): DeviceGui {
            return new DeviceGui();
        }

        constructor() {
            // empty constructor
            this.guiUrl = '';
            this.apiUrl = '';
            this.absolute = false;
            this.proxyType = '';
        }

        public IsEmpty(): boolean {
            return (this.guiUrl === '');
        }

        public equals(deviceGui: IDeviceGui): boolean {
            return deviceGui !== undefined && this.guiUrl === deviceGui.guiUrl;
        }
    }
}
